import React from "react"
import contentStyles from "./content.module.css"

const Content = ({ children, theme }) => {
  let mainClasses
  let secondaryClasses
  if (theme === "top") {
    mainClasses = `${contentStyles.mainWrp} ${contentStyles.mainWrpTop}`
    secondaryClasses = `${contentStyles.secondaryWrp} ${contentStyles.secondaryWrpTop}`
  }
  if (theme === "bottom") {
    mainClasses = `${contentStyles.mainWrp} ${contentStyles.mainWrpBottom}`
    secondaryClasses = `${contentStyles.secondaryWrp} ${contentStyles.secondaryWrpBottom}`
  }
  return (
    <section className={mainClasses}>
      <div className={secondaryClasses}>{children}</div>
    </section>
  )
}

export default Content
